import Logo from "@visa/vds/dist/_logos/visa/visa_vbm_wht.svg";
import Col from "@visa/vds/col";
import Footer from "@visa/vds/footer";
import FooterCopyright from "@visa/vds/footer-copyright";
import FooterLinks from "@visa/vds/footer-links";
import FooterLogo from "@visa/vds/footer-logo";
import FooterLogoCol from "@visa/vds/footer-logo-col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import React from "react";
import { TERMS_OF_USE } from "../_constants/PageRoutes";
import "../styles/VDSFooter.css";

const MCSFooter = () => {
  return (
    <>
      <Footer className="vss-footer" position="relative">
        <Grid>
          <Row noGutter>
            <FooterLogoCol xs={4} md={4} lg={6}>
              <FooterLogo src={Logo} alt="Visa logo" />
            </FooterLogoCol>
            <Col xs={4} md={3} lg={3} xl={3}>
              <FooterLinks tag="ul">
                <li>
                  <a href={TERMS_OF_USE} target="_blank" rel="noopener noreferrer">Terms of Use</a>
                </li>
                <li>
                  <a href="https://usa.visa.com/legal/privacy-policy.html">Privacy Notice</a>
                </li>
              </FooterLinks>
            </Col>
          </Row>
          <Row noGutter>
            <Col xs={4} md={3} lg={4} xl={3}>
              <FooterCopyright>
                {`Copyright © ${new Date().getFullYear()} Visa Inc. All Rights Reserved`}
              </FooterCopyright>
            </Col>
          </Row>
        </Grid>
      </Footer>
    </>
  );
};
export default MCSFooter;
